import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IEmailMessage } from 'src/app/shared/models/emailMessage';
import { BehaviorSubject } from 'rxjs';
import { MessagesService } from 'src/portal/pages/messages/messages.service';

@Component({
  selector: 'message-portal-content',
  styleUrls: ['message-portal-content.component.scss'],
  templateUrl: 'message-portal-content.component.html',
  standalone: false
})
export class MessagePortalContentComponent implements OnInit {
  private failedSubject = new BehaviorSubject<boolean>(false);
  public failed$ = this.failedSubject.asObservable();
  loaded = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: Pick<IEmailMessage, 'id' | 'subject' | 'senderName' | 'sender' | 'sentOn'>,
    private messageService: MessagesService,
    private dialogRef: MatDialogRef<MessagePortalContentComponent>
  ) {}

  @ViewChild('iframe', { static: false }) iframe: ElementRef<HTMLIFrameElement>;

  ngOnInit(): void {
    this.failedSubject.next(false);

    if (this.data.id) {
      this.messageService
        .getMessageById(this.data.id)
        .then((result) => {
          if (result) {
            this.injectHtml(result.html);
          } else {
            this.failedSubject.next(true);
          }
        })
        .catch(() => this.failedSubject.next(true));
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  private injectHtml(html: string) {
    // inject the html into the iframe using native DOM manipulation
    const { document } = this.iframe.nativeElement.contentWindow;

    document.body.innerHTML = html;

    // disable links for email previews (but not messages in the message center, which have an ID)
    if (!this.data.id) {
      const anchors = document.getElementsByTagName('A');
      for (let i = 0; i < anchors.length; ++i) {
        const anchor = anchors[i];
        // disable links, but include a tooltip so users can see where it will go
        anchor.setAttribute('title', anchor.getAttribute('href'));
        anchor.setAttribute('href', '#');
      }
    }

    this.loaded = true;
  }
}
